<template>
  <div class="">
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <!-- Filters and Action Buttons -->
      <div class="clearfix row py-2 mb-2 no-margin align-items-end">
        <div class="col-md-2 pl-0">
          <b-form-group label="Date" label-for="date" class="mb-0">
            <b-input-group class="mb-0">
              <b-form-input id="date" name="date" v-model="date" type="text" placeholder="YYYY-MM-DD" autocomplete="off" />
              <b-input-group-append class="mb-0">
                <b-form-datepicker class="mb-0" id="dp_date" button-only right locale="en-US" v-model="date" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-md-10 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="resetView()">Reset Selection</b-button>
            <b-button variant="primary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
            <b-button variant="primary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>

      <!-- Preview Mode -->
      <div class="mt-3" v-if="is_preview">
        <div class="card-body container px-0">
          <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
              <b-overlay :show="showoverlay_list" rounded="sm">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover dataTable">
                    <thead>
                      <tr class="table-head">
                        <th>Employee Code</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Job Position</th>
                        <th>Date</th>
                        <th>Mobility Type</th>
                        <th>In Time</th>
                        <th>Out Time</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in preview_data" :key="index" @click="showActivityLog(item)" style="cursor: pointer;">
                        <td>{{ item.employee_code }}</td>
                        <td>{{ item.employee_name }}</td>
                        <td>{{ item.department }}</td>
                        <td>{{ item.jobposition }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.location }}</td>
                        <td>{{ item.in_time }}</td>
                        <td>{{ item.out_time }}</td>
                        <td>{{ item.remarks }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="preview_data.length === 0" class="list-no-data text-center py-4">No records found.</div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>

      <!-- Selection / Grid Setup Mode -->
      <div v-else class="row" id="assignment">
        <div class="col-12 mt-3">
          <b-badge class="d-inline mb-3" variant="info">Selected Employees: {{ employee_ids.length }}</b-badge>
          <div class="card border-0 no-shadow">
            <common-list  :checkbox="1"  :is_action="0"  :appended_column="[]"  :key="list_key" :company_options="company_options" :employees="custom_list" :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn" />
          </div>
        </div>
      </div>
    </b-overlay>

    <!-- Activity Log Modal -->
    <b-modal id="activity_logModal" size="lg" scrollable hide-footer title="Attendance Mobility Activity Log">
      <div class="row no-margin" v-if="selected_row">
        <div class="col-md-12">
          <div class="border-0">
            <div class="card-body px-0 pt-0">
              <h5 class="card-title text-primary mb-3">
                {{ selected_row.employee_name }} <small class="text-muted">({{ selected_row.employee_code }})</small>
              </h5>
              <div class="mb-3">
                <strong>Date:</strong> {{ selected_row.date }}
              </div>
              
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-head">
                    <tr class="">
                      <th>Time</th>
                      <th>Mobility Type</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, idx) in selected_row.activity_log" :key="idx">
                      <td>{{ log.time }}</td>
                      <td>{{ log.location }}</td>
                      <td>{{ log.remarks }}</td>
                    </tr>
                    <tr v-if="!selected_row.activity_log || selected_row.activity_log.length === 0">
                      <td colspan="3" class="text-center text-muted">No activity logs recorded.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      checkbox: 1,
      list_key: 0,
      custom_list: [],
      default_column: ['name', 'employee_code', 'jobposition', 'branch', 'department'],
      primary_key: 'employee_id',
      company_options: [],
      employee_ids: [],
      preview_data: [],
      selected_row: null,
      is_preview: false,
      showoverlay: false,
      showoverlay_list: false,
    }
  },
  methods: {
    showActivityLog(item) {
      this.selected_row = item;
      this.$bvModal.show('activity_logModal');
    },

    resetView() {
      this.is_preview = false;
      this.preview_data = [];
      this.selected_row = null;
      this.employee_ids = [];
      this.list_key++;
      this.getEmployeesList();
    },

    listReturn(data) {
      this.employee_ids = data.selected;
    },

    getEmployeesList() {
      this.showoverlay = true;
      axios.get(this.$api_url + '/leave-attendance/employees/list', { params: { all: this.all, fields: 'offday,roster,shift', from: this.from_date, to: this.to_date } }).then(response => {
        this.custom_list = response.data.employee_data;
        this.company_options = response.data.options;
        this.list_key++;
        this.showoverlay = false;
      }).catch(error => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    previewOrDownload(flg) {
      if (!this.checkNet()) return false;

      let currentObj = this;
      if (flg === 0) {
        this.$bvToast.toast('Generating the preview, please hold tight.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      } else if (flg === 1) {
        this.$bvToast.toast('We are downloading the report, this may take a while.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      }

      this.showoverlay = true;
      this.showoverlay_list = true;

      let config = {};
      if (flg === 1) {
        config = {
          responseType: 'blob'
        };
      }
      let formData = new FormData();
      formData.append('date', this.date);
      formData.append('employee_ids', JSON.stringify(this.employee_ids));
      formData.append('is_export', flg);

      axios.post(this.$api_url + '/leave-attendance/attendance-mobility-report', formData, config).then(response => {
        this.showoverlay = false;
        this.showoverlay_list = false;

        if (flg === 0) {
          this.preview_data = response.data;
          this.is_preview = true;
        } else if (flg === 1) {
          this.global_download_file_content(response);
        }
      }).catch(error => {
        this.showoverlay = false;
        this.showoverlay_list = false;
        currentObj.serverError(error);
      });
    }
  },
  created() {
    this.getEmployeesList();
  }
}
</script>
